<template>
  <div class="productProcess">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.WORKMANSHIP') }}
    </div>
    <div class="productProcess-list" v-for="(item, index) in data" :key="index">
      <div class="dian1">
        <span>{{ $tc('lang.ReportsDetail.Defect_Description') }}</span>
        <span>{{ item.defect.defectDesc }}</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.ReportsDetail.Defect_Quantity') }}</span>
        <span>{{ item.defect.defectQuantity }}</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.ReportsDetail.Defects') }}</span>
        <span>{{ yan(item.defect.defectLevel) }}</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.ReportsDetail.Remark') }}</span>
        <span>{{ item.defect.defectRemark }}</span>
      </div>
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.ReportsDetail.Defect') }}</span>
        <div class="img">
          <show-img
            :data="item.media"
            :otherData="{
              mediaName: '',
              mediaType: '',
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
          <!-- <img
            v-for="img in item.media"
            :key="img.id"
            :src="config.baseUrlImg + img.mediaPath"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  data() {
    return {
      data: [],
    };
  },
  computed: {
    details: {
      get() {
        return JSON.parse(JSON.stringify(this.$store.state.report.details));
      },
    },
    // imgList: {
    //   get() {
    //     return this.$store.state.report.imgList;
    //   },
    //   set(val) {
    //     this.$store.commit('report/save', { imgList: val });
    //   },
    // },
  },
  created() {
    this.getSelectDate();
  },
  components: {
    showImg,
  },
  methods: {
    // 1、严重、2、主要、3、次要
    yan(value) {
      if (value == 1) {
        return this.$tc('lang.ReportsDetail.Critical');
      } else if (value == 2) {
        return this.$tc('lang.ReportsDetail.Major');
      } else if (value == 3) {
        return this.$tc('lang.ReportsDetail.Minor');
      } else {
        return value;
      }
    },
    getSelectDate() {
      this.$http
        .post('/hzwmj/inspect-defect/selectDate', {
          orderNo: this.details.orderId,
          reportNo: this.details.ireportId,
        })
        .then(data => {
          if (data.data) {
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
  },
};
</script>
<style lang="less">
.productProcess {
  .productProcess-list {
    margin-bottom: 20px;
    text-align: left;
  }
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 120px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .dian1 {
    margin-bottom: 10px;
    span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
  }
}
</style>
